import { GithubIcon } from "#components/ui/GithubIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const githubManifest: IntegrationManifest = {
    key: "github",
    displayName: "GitHub",
    nameKey: "channels.github",
    descriptionKey: "githubDescription",
    trayDescriptionKey: "composerTrayDescriptions.github",
    cardDescriptionKey: "connectIntegration.descriptions.github",
    connectedContentKeys: ["githubRepositories"],
    brandColor: "#181717",
    iconUrl: IconAssets.Github,
    iconUrlAlt: IconAssets.GithubAlt,
    // Near-black mark; unreadable on dark wherever it renders without a plate.
    iconUrlDark: IconAssets.GithubDark,
    iconUrlAltDark: IconAssets.GithubAltDark,
    glyph: GithubIcon,
    channelType: "UserGithubMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: []
};
